import { createSelector } from 'reselect';

import getPropFromModule from './getPropFromModule';
import { SECTIONS_LIST } from '../model';

const getSectionsList = createSelector(
  state => getPropFromModule(state, SECTIONS_LIST),
  sectionsList => (sectionsList ? sectionsList.toJS() : []),
);

export default getSectionsList;
